import { Link } from "react-router-dom";

export default function SiteIntro() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-1 h-4 rounded-full bg-accent-500" />
              <span className="text-xs md:text-sm font-medium tracking-widest text-accent-700">
                关于本站
              </span>
            </div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              用心整理每一个家庭的故事情节
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-5">
              《公公与儿媳》是一部聚焦三代同堂生活的家庭题材电视剧。本站为方便观众了解剧情，
              系统梳理了全剧 20 集的分集梗概、主要角色的性格与关系，以及播出过程中的相关资讯。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-4">
              无论你是刚入坑的新观众，还是想重温剧情的老朋友，都可以在这里快速找到想看的内容。
              我们始终坚持：只做真实、清晰的剧情介绍，不提供视频播放与下载，不做任何夸大宣传。
            </p>
            <div className="flex flex-wrap gap-3 mt-7">
              <Link
                to="/episodes"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
              >
                <i className="ri-book-open-line" />
                开始浏览剧情
              </Link>
              <Link
                to="/characters"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50 border border-background-300 hover:border-primary-300 text-foreground-800 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
              >
                <i className="ri-user-heart-line" />
                认识剧中角色
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 md:gap-5">
            {[
              { value: "20", unit: "集", label: "全剧剧情介绍", icon: "ri-film-line" },
              { value: "8", unit: "位", label: "主要角色档案", icon: "ri-group-line" },
              { value: "12", unit: "条", label: "影视相关资讯", icon: "ri-article-line" },
              { value: "100", unit: "%", label: "模拟演示数据", icon: "ri-shield-check-line" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col gap-3 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                  <i className={`${stat.icon} text-2xl`} />
                </span>
                <span className="flex items-baseline gap-1">
                  <span className="font-heading font-black text-3xl md:text-4xl text-primary-600">
                    {stat.value}
                  </span>
                  <span className="text-sm text-foreground-500">{stat.unit}</span>
                </span>
                <span className="text-xs md:text-sm text-foreground-600">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}